__turbopack_context__.v({
  "card": "Cbyydq_card",
  "text": "Cbyydq_text",
});
